import { Box, Typography, Skeleton, Button } from "@mui/joy";

export function SupplierComparisonSkeleton() {
    return (
        <Box mt={4}>
            <Box mb={2}>
                <Typography level="title-md" fontWeight="bold" mb={2}>
                    <Skeleton>Select Suppliers to Compare</Skeleton>
                </Typography>
                <Box display="flex" gap={3} flexWrap="wrap">
                    {[1, 2, 3].map((item) => (
                        <Box key={item} display="flex" alignItems="center" gap={1}>
                            <Skeleton variant="rectangular" width={20} height={20} sx={{ borderRadius: "xs" }} />
                            <Skeleton variant="text" width={120} />
                        </Box>
                    ))}
                </Box>
            </Box>

            <Button
                variant="soft"
                color="primary"
                disabled
                sx={{ border: "1px solid", borderColor: "divider" }}
            >
                Compare Suppliers
            </Button>
        </Box>
    );
}

export default SupplierComparisonSkeleton;
